import { getAccessToken } from "../utils/storage";
import Axios from "../utils/http-request";
import { PostApiProp, RepresentativeApiProp } from "../interface/api";

export const apiGlobalSearch = async (values: {
  page: number;
  search: string;
  page_size: number;
  state: string;
  local_government: string;
  representative_id: string;
}) => {
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/search?search=${values.search}&page=${values.page}&page_size=${values.page_size}&state=${values.state}&local_government=${values.local_government}&representative_id=${values.representative_id}`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${accessToken}`,
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.details || e?.details,
    };
  }
};

export const apiGetRepresentative = async (values: RepresentativeApiProp) => {
  const { accessToken, tokenType } = await getAccessToken();
  try {
    
    
    const uri = `/accounts/representatives?state=${values.state}&local_government=${values.local_government}&position=${values.position}&sort_by=${values.sort_by}&sort_order=${values.sort_order}&page=${values.page}&page_size=${values.page_size}`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${accessToken}`,
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.details || e?.details,
    };
  }
};

export const apiGetPost = async (values: PostApiProp) => {
  try {
    const uri = `/posts?search=${values.search}&status=${values.status}&category=${values.category}&sort_by=${values.sort_by}&sort_order=${values.sort_order}&page=${values.page}&page_size=${values.page_size}`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.details || e?.details,
    };
  }
};
